import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, Trash2Icon } from 'lucide-react';
import { SongRow } from '../SongRow';
import { Button } from '../ui/Button';
import { genres } from '../../data/options';
import { spring } from '../../utils/motion';
import type { SongKey } from '../../types/marketplace';
interface KeysEditorProps {
  keys: SongKey[];
  onChange: (keys: SongKey[]) => void;
}
const field = 'h-11 w-full rounded-sm border border-line bg-surface px-3.5 text-[15px] placeholder:text-ink-3 focus:border-ink focus:outline-none';
export function KeysEditor({
  keys,
  onChange
}: KeysEditorProps) {
  const [adding, setAdding] = useState(false);
  const [title, setTitle] = useState('');
  const [artist, setArtist] = useState('');
  const [genre, setGenre] = useState('Soul');
  const add = () => {
    if (!title.trim()) return;
    onChange([...keys, {
      id: `k-${Date.now()}`,
      title: title.trim(),
      artist: artist.trim() || 'Original',
      genre,
      sample: false
    }]);
    setTitle('');
    setArtist('');
    setAdding(false);
  };
  return <div data-id="element-595" data-mp="3v72oyqe0xpod">
      <ul className="space-y-1" data-id="element-596" data-mp="3v6uc2yhwikd6">
        <AnimatePresence initial={false} data-id="element-597" data-mp="3v7vlyzn6l0tb">
          {keys.map(k => <motion.li key={k.id} layout initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={spring.smooth} className="rounded-sm py-2" data-id="element-598" data-mp="409lffvrdego">
              <SongRow song={k} trailing={<button type="button" onClick={() => onChange(keys.filter(x => x.id !== k.id))} aria-label={`Remove ${k.title}`} className="grid h-9 w-9 place-items-center rounded-full text-ink-3 transition-colors duration-150 hover:bg-surface-2 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-600" data-mp="mrah9v1l0tw0">
                    <Trash2Icon className="h-4 w-4" data-id="element-601" data-mp="2li2k24zsfcoi" />
                  </button>} data-id="element-599" data-mp="hro3nkhudbmo" />
            </motion.li>)}
        </AnimatePresence>
      </ul>
      <AnimatePresence mode="wait" initial={false} data-id="element-602" data-mp="2vgjhnkt8epjj">
        {adding ? <motion.form key="form" initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={spring.smooth} onSubmit={e => {
        e.preventDefault();
        add();
      }} className="mt-3 grid gap-2 rounded-md bg-surface-2 p-3 sm:grid-cols-[1fr_1fr_130px]" data-id="element-603" data-mp="2qg45gwkoro35">
            <input autoFocus value={title} onChange={e => setTitle(e.target.value)} placeholder="Song title" aria-label="Song title" className={field} data-id="element-604" data-mp="398g5vdrs4fan" />
            <input value={artist} onChange={e => setArtist(e.target.value)} placeholder="Original artist" aria-label="Original artist" className={field} data-id="element-605" data-mp="3j5b5jzzsglqi" />
            <select value={genre} onChange={e => setGenre(e.target.value)} aria-label="Genre" className={field} data-id="element-606" data-mp="6m8besh2145c">
              {genres.map(g => <option key={g} data-id="element-607" data-mp="3st6v2jdypq1h">{g}</option>)}
            </select>
            <div className="flex gap-2 sm:col-span-3" data-id="element-608" data-mp="3svb2hbb2l76i">
              <Button variant="ghost" size="sm" onClick={() => setAdding(false)} data-id="element-609" data-mp="1lc7wg0m7k0g">
                Cancel
              </Button>
              <Button type="submit" variant="primary" size="sm" disabled={!title.trim()} data-id="element-610" data-mp="3j10x8t114eed">
                Add to Keys
              </Button>
            </div>
          </motion.form> : <motion.div key="btn" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.12
      }} className="mt-3" data-id="element-611" data-mp="3a0cgvro5y1yb">
            <Button variant="secondary" size="sm" icon={<PlusIcon className="h-4 w-4" data-id="element-613" data-mp="306cgg33ttkvx" />} onClick={() => setAdding(true)} data-id="element-612" data-mp="303zoqy89nw5o">
              Add a song
            </Button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}